import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';
import { CommonModule } from '@angular/common';
import { TextFieldModule } from '@angular/cdk/text-field';
import { TextareaComponent } from './textarea/textarea.component';
import { FormControlComponent } from './form-control/form-control.component';
import { FieldErrorComponent } from './field-error/field-error.component';
import { EditableFieldComponent } from './editable-field/editable-field.component';
import { InputNumberComponent } from './input-number/input-number.component';
import { InputDateComponent } from './input-date/input-date.component';
import { InputTimeComponent } from './input-time/input-time.component';
import { ButtonComponent } from './button/button.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { InputComponent } from './input/input.component';
import { SelectComponent } from './select/select.component';
import { RadioGroupComponent } from './radio-group/radio-group.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { DateAdapterService } from './service/date-adapter.service';
import { JsonFormComponent } from './json-form/json-form.component';
import { TabComponent } from './tab/tab.component';
import { ImageSelectComponent } from './image-select/components/image-select/image-select.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ImageSelectResource } from './image-select/resources/image-select.resource';
import { ImageSelectService } from './image-select/service/image-select.service';
import { DownloadButtonComponent } from './download-button/download-button.component';
import { PopupMenuComponent } from './popup-menu/popup-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { SpinnerComponent } from './spinner/spinner.component';

@NgModule({
	providers: [DateAdapterService, ImageSelectService, ImageSelectResource],
	declarations: [
		TextareaComponent,
		FormControlComponent,
		FieldErrorComponent,
		EditableFieldComponent,
		InputNumberComponent,
		InputDateComponent,
		InputTimeComponent,
		ButtonComponent,
		TooltipComponent,
		CheckboxComponent,
		InputComponent,
		SelectComponent,
		RadioGroupComponent,
		AutocompleteComponent,
		JsonFormComponent,
		TabComponent,
		ImageSelectComponent,
		DownloadButtonComponent,
		PopupMenuComponent,
		SpinnerComponent,
	],
	imports: [
		RouterModule,
		MatFormFieldModule,
		FormsModule,
		MatInputModule,
		MatButtonModule,
		MatCheckboxModule,
		MatSelectModule,
		MatButtonModule,
		MatIconModule,
		MatCheckboxModule,
		MatRadioModule,
		MatTooltipModule,
		MatSlideToggleModule,
		CommonModule,
		DirectivesModule,
		PipesModule,
		MatDatepickerModule,
		MatListModule,
		TextFieldModule,
		MatAutocompleteModule,
		MatProgressSpinnerModule,
		ReactiveFormsModule,
		TranslateModule,
		MatDialogModule,
		MatMenuModule,
	],
	exports: [
		MatFormFieldModule,
		MatButtonModule,
		MatSlideToggleModule,
		MatTooltipModule,
		MatIconModule,
		MatRadioModule,
		MatCheckboxModule,
		MatSelectModule,
		FormsModule,
		CommonModule,
		DirectivesModule,
		PipesModule,
		MatInputModule,
		MatListModule,
		TextFieldModule,
		MatAutocompleteModule,
		EditableFieldComponent,
		TextareaComponent,
		InputNumberComponent,
		InputDateComponent,
		InputTimeComponent,
		ButtonComponent,
		TooltipComponent,
		CheckboxComponent,
		InputComponent,
		SelectComponent,
		RadioGroupComponent,
		AutocompleteComponent,
		FieldErrorComponent,
		JsonFormComponent,
		TabComponent,
		ImageSelectComponent,
		DownloadButtonComponent,
		PopupMenuComponent,
		SpinnerComponent,
	],
})
export class ControlsModule {}

export * from './json-form/json-form.component';
export * from './image-select/components/image-select/image-select.component';
export * from './download-button/download-button.component';
export * from './popup-menu/popup-menu.component';
